import { render } from "./p-address-input.vue?vue&type=template&id=06b8028f&scoped=true"
import script from "./p-address-input.vue?vue&type=script&lang=js"
export * from "./p-address-input.vue?vue&type=script&lang=js"

import "./p-address-input.vue?vue&type=style&index=0&id=06b8028f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b8028f"]])

export default __exports__